// https://material.io/develop/web/components/cards/
import React from "react";
import styled from "styled-components";
import classNames from "classnames";
import "@material/card/mdc-card.scss";
import Title from "./Title";

const StyledCard = styled.div`
  position: relative;
  background-color: ${({ isDanger }) =>
    isDanger && "rgba(202, 21, 21, 0.12) !important"};
`;

const StyledActionButton = styled.div`
  width: ${({ stacked }) => stacked && "100%"};
  flex-direction: ${({ stacked }) => stacked && "column"};
`;

const Primary = styled.div`
  margin: 1rem;
`;

const Subtitle = styled.h3`
  margin: 0;
`;

export default class Card extends React.Component {
  render() {
    const {
      title,
      subtitle,
      actionButtons,
      actionIcons,
      actionStacked,
      className,
      footer,
      ...rest
    } = this.props;

    return (
      <StyledCard className={classNames(className, "mdc-card")} {...rest}>
        {title && (
          <Primary>
            <Title>{title}</Title>
            {subtitle && (
              <Subtitle className="mdc-typography--subtitle2">
                {subtitle}
              </Subtitle>
            )}
          </Primary>
        )}
        {this.props.children}
        {(actionButtons || actionIcons) && (
          <div className="mdc-card__actions">
            {actionButtons && (
              <StyledActionButton
                className="mdc-card__action-buttons"
                stacked={actionStacked}
              >
                {actionButtons}
              </StyledActionButton>
            )}
            {actionIcons && (
              <div className="mdc-card__action-icons">{actionIcons}</div>
            )}
          </div>
        )}
        {footer}
      </StyledCard>
    );
  }
}
